import {ThemeRadiiNames} from '../../types';

export const Radii: ThemeRadiiNames = {
  '4': 4,
  '8': 8,
  '16': 16,
  '9999': 9999,
};
